import { render, staticRenderFns } from "./adminSuggest.vue?vue&type=template&id=4de94ff6&"
import script from "./adminSuggest.vue?vue&type=script&lang=ts&"
export * from "./adminSuggest.vue?vue&type=script&lang=ts&"
import style0 from "./adminSuggest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports